<template>
  <div v-if="newList.length>0">
      <div class="row flex" v-for="(row,index) in newList" :key="index">
           <div class="img-box" v-for="img in row" :key="img.id" :style="{'width':img.width,'height':img.height}">
              <el-image :src="img.url" alt="图片加载失败" :style="{'width':img.width + 'px','height':img.height + 'px'}" lazy></el-image></el-image>
          </a>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['imgs'],
  data: function () {
    return {
      screenWidth: document.body.clientWidth,
      imgsData: [], // 实际操作的图片列表
      timer: null
    }
  },
  mounted () {
    const self = this
    // 添加监听浏览器resize事件
    self.$nextTick(() => {
      self.screenWidth = document.body.clientWidth
      window.addEventListener('resize', function () {
        self.throttle(() => {
          self.screenWidth = document.body.clientWidth
        }, 100)
      })
    })
    // 转存传过来的props里的imgs数据
    self.imgsData = self.imgs
  },
  watch: {
    // 监听浏览器宽度
    screenWidth (val) {
      this.screenWidth = val
      // 宽度一旦发生变化就开始重新排列
      this.realignImgs()
    }
  },
  computed: {
    newList () {
      // 接收的参数是baseheight，图片的基础高度
      return this.realignImgs(427)
    }
  },
  methods: {
    // 节流
    throttle (fn, wait, scope) {
      clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        fn.apply(scope)
      }, wait)
    },
    // 处理数据
    realignImgs (baseheight) {
      // baseheight是设置的基础高度，后面的高度都是根据这个基础上下浮动的
      const newList = []
      // 设定一个浏览器宽度的最低值为1000px
      const screenWidth = Number(this.screenWidth) > 1000 ? Number(this.screenWidth) : 1000

      // 先把设定的基础高度当作行高
      const rowHeight = baseheight
      let arrRow = []
      let imgsData = []
      // 深拷贝转储一下
      imgsData = JSON.parse(JSON.stringify(this.imgsData))
      // 循环 计算每个图片的宽度
      for (let i = 0; i < imgsData.length; i++) {
        const item = imgsData[i]
        // 计算图片的宽高比
        item.ratio = Number(item.width) / Number(item.height)
        console.log(item.ratio)
        // 新的宽度，算法是比例乘以行高
        const newWidth = parseInt(item.ratio * rowHeight)
        item.width = newWidth
        item.height = rowHeight
        // 定义该行图片宽度之和
        let totalWidth = 0
        arrRow.push(item)
        for (let i = 0; i < arrRow.length; i++) {
          totalWidth += arrRow[i].width
        }
        // 如果该行加入的图片宽度大于了该行的宽度
        // 就需要弹出最后一张图片，并更改前面的图片大小比例
        if (totalWidth > screenWidth) {
          // 把最后一张弹出，恢复原来的wholeWidth
          const lastImg = arrRow.pop()
          totalWidth -= lastImg.width
          // 利用面积相等原则，来计算新的高度
          const newHeight = screenWidth * rowHeight / totalWidth
          // 这里是根据一行图片的数量，计算需要留出的边距
          const marginSpace = (arrRow.length - 1) * 20
          // 重新计算宽高，占满一行
          for (let i = 0; i < arrRow.length; i++) {
            // 最后再把每张图片等比例缩小一点，以留出边距
            arrRow[i].width = newHeight * arrRow[i].ratio - marginSpace
            arrRow[i].height = newHeight - (marginSpace / arrRow[i].ratio)
          }
          // 放置完毕之前的图片之后，清空该图片队列
          // 并将上一行溢出的图片 作为下一行的第一张
          newList.push(arrRow)
          arrRow = []
          arrRow.push(lastImg)
        }
      }
      // 单独处理未最后一行
      // 遍历每一行，把每一行的长度都加起来，这样才能得出最后一行的元素数量
      let tmp = 0
      for (let i = 0; i < newList.length; i++) {
        tmp += newList[i].length
      }
      const lastRow = []
      for (let i = tmp; i < imgsData.length; i++) {
        // 高度就以设置好的基础高度为基准了
        imgsData[i].height = rowHeight
        // 宽度也是按照比例算的
        imgsData[i].width = imgsData[i].ratio * rowHeight
        lastRow.push(imgsData[i])
      }
      newList.push(lastRow)
      return newList
    }
  }
}
</script>

<style scoped>
.row {
  margin: 40px 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 80vw;
}

a {
  text-align: center;
}

.img-box {
  margin: 0 10px;
  transition: all 0.5s;
  width: 25vw;
}

.img-box>img {
  transition: all 0.5s;
}

.img-box:hover {
  transform: scale(1.05);
}

.img-box:hover>img {
  transform: scale(1.05);
}

</style>

